var map = {
	"./alert.png": 93634,
	"./burger.png": 57525,
	"./buy.webp": 13017,
	"./cart.png": 14328,
	"./cart_empty.png": 47022,
	"./cashback.png": 99710,
	"./coin-bottom.webp": 3886,
	"./coin-top.webp": 57460,
	"./coin.webp": 75830,
	"./coin1.webp": 73413,
	"./coin2.webp": 89016,
	"./coins.png": 96970,
	"./cup.webp": 24461,
	"./cup1.webp": 83952,
	"./cup2.webp": 26781,
	"./cup3.webp": 2066,
	"./drink.png": 9066,
	"./flower.webp": 20816,
	"./full_cost.png": 93033,
	"./gift.webp": 61501,
	"./hands.webp": 16847,
	"./hat.png": 6739,
	"./in_hall.png": 84105,
	"./location.png": 40827,
	"./mobile-order.png": 31095,
	"./new.webp": 78071,
	"./note.webp": 34727,
	"./note2.webp": 23639,
	"./pazl.webp": 65406,
	"./percent.webp": 87364,
	"./personalization.png": 70492,
	"./phone.png": 61604,
	"./picked.png": 10322,
	"./t-coin.png": 92824,
	"./thunder.webp": 17095,
	"./time.png": 75321,
	"./tubatay.webp": 56445,
	"./univer.webp": 57892,
	"./warning.png": 82616,
	"./with_him.png": 97765
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96916;